import plangridTrackEvents, { trackEvent } from "./amplitudeInit-vanilla";
import { getPageNameFromLocation } from "../../pages/helpers/analytics";

const addFormHandler = pagename => {
  const formNode = document.querySelector('form[name="resource-asset"]');
  const formContainer = document.querySelector(".resource-asset-body");

  if (!formNode) return;

  if (sessionStorage.getItem("pgMarketingFormFilled")) {
    formContainer.classList.add("confirmation");
    return;
  }

  const submitResourceForm = () => {
    const resourceForm = MktoForms2.getForm(1096);

    resourceForm.onSuccess((values, followUpUrl) => {
      formContainer.classList.add("confirmation");
      sessionStorage.setItem("pgMarketingFormFilled", true);
      return false;
    });

    resourceForm.setValues({
      FirstName: formNode["First name"].value,
      LastName: formNode["Last name"].value,
      Email: formNode.Email.value,
      Company: formNode.Company.value,
      Phone: formNode["Phone number"].value,
    });

    resourceForm.submit();
  };

  formNode.addEventListener("submit", e => {
    e.preventDefault();

    submitResourceForm();
  });
};

const init = () => {
  MktoForms2.loadForm("//app-ab10.marketo.com", "572-JSV-775", 1096);
  const pagename = getPageNameFromLocation(window.location.href);
  plangridTrackEvents(pagename);
  addFormHandler(pagename);
};

document.addEventListener("DOMContentLoaded", init);



// WEBPACK FOOTER //
// ./src/assets/js/resourceAsset.js